import { theme } from 'lib';
import styled from 'styled-components';

/*
  Shared full-screen backdrop for every CTAScreenV2 screen: matches the mobile
  Team Profile hero gradient (purple at the top fading into black).
  Fills the whole viewport — the app header is hidden on /shoutout/:username routes;
  screens lay out their own content inside.
*/
const GradientBackground = styled.div`
  position: relative; /* anchors screen-level overlays, e.g. the intro back button */
  width: 100%;
  /* dvh (not vh) so mobile browser chrome doesn't make the backdrop taller than
     the visible viewport, which forces a small scroll even when content fits */
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${({ justify }) => justify || 'center'};
  box-sizing: border-box;
  padding: 40px 24px;
  background: ${theme.TEAM_HERO_GRADIENT};

  /* isMobile in appState is innerWidth < 1024 — keep the breakpoint in sync */
  @media (max-width: 1023px) {
    padding: 16px 16px;
  }
`;

export default GradientBackground;
